import type { Route } from "@route-types/Section/+types/Section";
import FeatureCard from "@src/app/components/ArticleCard/FeatureCard";
import PageArticleList from "@src/app/components/ArticleList/PageArticleList";
import { createMetaTags } from "@src/app/components/MetaTags/MetaTags";
import SectionContainer from "@src/app/components/SectionContainer";
import TopArticles from "@src/app/components/TopArticles";
import VideoStrip from "@src/app/components/VideoStrip";
import { useRouteResponse } from "@src/app/hooks/useRouteResponse";

import { fetchSectionPageData } from "./Section.server";

const metaInfo: Record<
  string,
  { title: string; description: string } | undefined
> = {
  perspective: {
    title: "观点 - 关于新加坡、亚洲与世界新闻的独立观点 - 红蚂蚁",
    description:
      "观点 - 深入剖析新加坡与全世界的最新时事。《红蚂蚁》以生动的笔调撰写独立观点，以新颖的手法呈现新闻，让读者被咬得直呼过瘾。",
  },
  overview: {
    title: "新闻 - 轻松读懂新加坡、亚洲与世界的热门时事 - 红蚂蚁",
    description:
      "新闻打包 - 一口气掌握新加坡、亚洲与全球时事。《红蚂蚁》以生动的笔调撰写独立观点，以新颖的手法呈现新闻，让读者被咬得直呼过瘾。",
  },
  "good-reads": {
    title: "特写 - 跟上新加坡最关心的生活话题 - 红蚂蚁",
    description:
      "特写 - 从吃喝玩乐到理财，全面掌握你最在意的生活话题。《红蚂蚁》以生动的笔调撰写独立观点，以新颖的手法呈现新闻，让读者被咬得直呼过瘾。",
  },
};

export const loader = fetchSectionPageData;

export const meta = (args: Route.MetaArgs) => {
  const section = args.params.level1 || "";

  const metaTitle = metaInfo[section]?.title || "";
  const metaDescription = metaInfo[section]?.description || "";

  return createMetaTags({
    title: metaTitle,
    description: metaDescription,
    canonical: `https://www.redants.sg/${section}`,
  });
};

export default function SectionPage() {
  const route = useRouteResponse("sectionPage");

  const heroArticle = route.heroArticles?.[0];
  const sectionName = route.sectionName || "";

  return (
    <div className="[&_*]:[overflow-anchor:none]">
      {heroArticle ? (
        <SectionContainer title={sectionName} className="lg:px-[24px]">
          <FeatureCard article={heroArticle} />
        </SectionContainer>
      ) : null}

      <TopArticles />

      <VideoStrip articles={route.videoArticles || []} />

      <PageArticleList
        initialData={route.articles || []}
        title={route.sectionName ? `所有${route.sectionName}` : ""}
        requestPath={`/page/${route.section}`}
        requestQuery={{
          excludeIds: route.heroArticles?.map((i) => i.id).join(",") || "",
        }}
        className="lg:px-[24px]"
      />
    </div>
  );
}
